module.exports = __webpack_public_path__ + "static/media/Add_Your_Hotel_Resort_Attraction_Tour.1d90ae7e.png";